import {
  FETCHING_INTEGRATION_OPPORTUNITIES, FETCHING_INTEGRATION_OPPORTUNITIES_SUCCEEDED,
  FETCHING_INTEGRATION_OPPORTUNITIES_FAILED, INVALIDATE_INTEGRATION_OPPORTUNITIES
} from '../actions/actionTypes.jsx';
  
const initialState = {
  loading: false,
  invalidated: true,
  succeeded: false,
  items: [],
  currentPage: -1,
  totalPages: 0,
  totalRecordsCount: 0,
  recordsPerPage: 12,
  loadMore: true,
};
   
function opportunityReducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING_INTEGRATION_OPPORTUNITIES:
      return Object.assign({}, state, {
        ...state,
        loading: true,
        succeeded: false,
      })

    case FETCHING_INTEGRATION_OPPORTUNITIES_SUCCEEDED:
      var items = [];
      var result = action.payload;
      var loadMore = result.currentPage <= result.totalPages;
      var records = result.records || [];
      items = [...state.items, ...records];

      items = items.reduce((x, y) => {
        var index = x.findIndex((e) => {
          return e.id == y.id;
        });

        if (index < 0) {
          return [...x, y];
        } else {
          x[index] = y;
          return x;
        }
      }, []);

      return Object.assign({}, state, {
        ...state,
        loading: false,
        invalidated: false,
        items: items,
        currentPage: result.currentPage,
        totalPages: result.totalPages,
        totalRecordsCount: result.totalRecordsCount,
        recordsPerPage: result.recordsPerPage,
        loadMore: loadMore,
        succeeded: true
      });

    case FETCHING_INTEGRATION_OPPORTUNITIES_FAILED:
      return Object.assign({}, state, {
        ...state,
        loading: false,
        invalidated: false,
        error: action.payload.error,
        succeeded: false,
      })

    case INVALIDATE_INTEGRATION_OPPORTUNITIES:
      return Object.assign({}, state, {
        loading: false,
        items: [],
        invalidated: true,
        currentPage: -1,
        totalPages: 0,
        totalRecordsCount: 0,
        recordsPerPage: 12,
        loadMore: true,
        succeeded: false,
      })

    default:
    return state
  }
}
  
export { opportunityReducer };